import LoginComponent from '../login-component';
import FormActions from '../../logic/form-actions';
import LoginInput from '../ui-elements/login-input';

import {localize} from '../../infrastructure/localization';

export default class ConfirmPasswordInput extends LoginComponent {

    constructor(props) {
        super(props);
    }

    get error() {
        return this.state.loginModel.validation.errors.confirmedPassword;
    }

    render() {
        return (
            <LoginInput
                componentId={this.state.componentId}
                id="login-confirmed-password"
                type="password"
                iconId="lock-on"
                value={this.state.loginModel.confirmedPassword}
                label={localize('form-components.confirm-password')}
                maxLength={256}
                onBlur={(e) => FormActions.endEditConfirmedPassword(this.state.componentId)}
                onChange={(e) => FormActions.changeConfirmedPassword(this.state.componentId, e.target.value)}
                error={this.error} />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/form-components/confirm-password-input.jsx
 **/